import {Component, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef} from '@angular/core';
import { HTTPSearchResultTour } from 'src/app/models';
import {environment} from "../../../../environments/environment";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";
import { CommonModule, DatePipe } from '@angular/common';
import {pluralize} from "../../pipes/pluralize/pluralize";
import {EventBusService} from "../../../services/event-bus.service";
import {HotelStarsComponent} from '../../hotel-stars/hotel-stars.component';
import {HotelRatingComponent} from '../../hotel-rating/hotel-rating.component';
import {HotelViewCountComponent} from '../../hotel-view-count/hotel-view-count.component';
import {TemplateReplacePipe} from '../../pipes/trmplate-replace/template-replace.pipe';

@Component({
  selector: 'app-tour-info',
  templateUrl: environment.mobile ? './tour-info.component.mobile.html' : './tour-info.component.html',
  styleUrls: environment.mobile ? ['./tour-info.component.mobile.scss'] : ['./tour-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, HotelStarsComponent, HotelRatingComponent, HotelViewCountComponent, TemplateReplacePipe]
})
export class TourInfoComponent {
  @Input() tour: HTTPSearchResultTour;

  messages: any = {};

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
  ) {
    this.messages = Object.assign(
      {},
      this.hotelToursPageConfig.translates.tourInfo,
      {
        daysPlural: this.hotelToursPageConfig.translates.plurals.daysPlural
      }
    );
  }

  ngOnInit() {

  }

  departureMapping(date, fromCity) {
    return {
      'date': this.dateFrom(date),
      'fromCity': fromCity,
    }
  }

  nightsMapping(value) {
    return {
      'countNightsValue': value,
      'countNightsText': pluralize(value, this.messages.daysPlural),
    }
  }

  get hotelName(): string {
    return this.tour.hotelName.toLowerCase().replace('&amp;', '&');
  }

  dateFrom(value) {
    return this.translatedDate(value, 'd MMM');
  }

  checkInDate(value) {
    return this.translatedDate(value, 'd MMM');
  }

  translatedDate(value, format) {
    const datePipe = new DatePipe(this.hotelToursPageConfig.language);

    return datePipe.transform(value, format, '', this.hotelToursPageConfig.language);
  }

  get reviewsCount() {
    return this.tour.bookingReviewsCount + this.tour.reviewsCount;
  }
}
